/*
* 课表控件, 思路是把多个显示不同时段的fullcalendar拼到一起,并自行实现工具栏上的功能
* 应该是有办法通过修改样式达到一个fullcalendar也能单屏展示的
*/
<template>
  <div style="position:release;">
    <v-flex flat class="display-flex justify-space-between">
      <v-card-actions class="d-inline-flex pl-0 mb-3 cursor-pointer" @click="gotoClassSetting">
        <v-icon class="mr-2 back-icon">
          arrow_back
        </v-icon>
        <span class="title font-weight-bold blue-title font-14">Class Time Setting</span>
      </v-card-actions>
      <div class="display-flex justify-space-between align-center">
        <div class="next-week-number">
          <span class="mr-2">{{ modifyNextWeekNumber }}</span>Plots for the next week
        </div>
        <v-flex class="fix-height ml-5">
          <p class="mt-3 mb-0 tool-bar-texts" v-show="toolTipType === 'on'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="ml-1">Add-Class Limit is off</span>
              </template>
              <span>You can freely add more slots 12 hours before the class starts on that day.</span>
            </v-tooltip>
          </p>
          <p class="mb-0 mt-3 tool-bar-text" v-show="toolTipType === 'off'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="ml-1">Add-Class Limit is on</span>
              </template>
              <span>You cannot add more slots if you have already plotted some on the the same day.</span>
            </v-tooltip>
          </p>
        </v-flex>

        <v-flex class="ml-5">
        <!-- && (!selfSchedulesEnable &&!setSelfSchedulesEnableThisTime) -->
          <v-btn class="text-none red-button ma-0"
               :disabled="(!selfSchedulesEnable&&SelfSchedulesThatDay ) || !canSubmit"
               @click="enSureRelease">Submit</v-btn>
      </v-flex>
      </div>
  </v-flex>
  <div class="calendar-card" >
    <!-- <v-layout class="toolbar"
              align-center
              justify-space-between>
      <v-flex class="fix-height">
        <p class="mt-3 mb-0 font-weight-bold tool-bar-texts" v-show="toolTipType === 'on'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">Add-class limit is off</span>
            </template>
            <span>You can freely add more slots 12 hours before the class starts on that day.</span>
          </v-tooltip>
        </p>
        <p class="mb-0 mt-3 font-weight-bold tool-bar-text" v-show="toolTipType === 'off'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">Add-class limit is on</span>
            </template>
            <span>You cannot add more slots if you have already plotted some on the the same day.</span>
          </v-tooltip>
        </p>
      </v-flex>
      <v-flex class="text-xs-center title"
              xs6>
        Class time setting
      </v-flex>
      <v-flex class="text-xs-right"
              xs4>
        <v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on" class="next-limit"> {{ modifyNextWeekNumber }}</span>
            </template>
            <span>The number of slots you can plot for the next week.</span>
          </v-tooltip>
        </v-spacer>
      </v-flex>
    </v-layout> -->
    <v-progress-linear indeterminate
                       v-if="loading"></v-progress-linear>
    <div class="week-calendar-container calendar-release">
      <div v-if="limitDay === 7" class="switch-date">
      <v-tooltip bottom v-show="addCount > 0">
        <v-btn @click="prevWeek()"
                fab
                slot="activator"
                small>
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <span>Previous</span>
      </v-tooltip>
      <v-tooltip bottom v-show="addCount < 2">
        <v-btn @click="nextWeek()"
                fab
                slot="activator"
                small>
          <v-icon>chevron_right</v-icon>
        </v-btn>
        <span>Next</span>
      </v-tooltip>
    </div>
      <fullcalendar-wrapper :calendar.sync="fullCalendarW"
                            :eventRender="weekCalendarEvent"
                            :events="calendarEvents"
                            :options="options"
                            @fetchingEvents="setViewRange"
                            class="week-calendar-items release-calendar"></fullcalendar-wrapper>
    </div>
    <!-- <v-layout class="toolbar pt-0"
              align-center
              justify-space-between>
     
      <v-flex class="text-xs-center title"
              xs12>
        <v-btn color="primary"
               class="text-none"
               :disabled="(!selfSchedulesEnable && !setSelfSchedulesEnableThisTime) || !canSubmit"
               @click="enSureRelease">Submit</v-btn>
      </v-flex>
    </v-layout> -->
  </div>
    
  </div>
</template>
<script>

// 未开放时间：白色
// 不可用时间：灰色
// 开放未选定时间：浅黄色
// 开放已选定时间：黄色

import fullcalendarWrapper from '@/components/fullcalendarWrapper'
import timeGridPlugin from '@fullcalendar/timegrid'
import '@fullcalendar/timegrid/main.css'
import weekCalendarEvent from './weekCalendarReleaseEvent'
import dateFilter from '@/filters/dateFilter'
import { createNamespacedHelpers } from 'vuex'
import { getRestCourseCountOfNextWeek } from '@/api/releaseTime'
import store from '@/store'
import { formatDate } from '@/utils/date'

const namespace = 'release'
const { mapGetters, mapActions } = createNamespacedHelpers(namespace)

export default {
  components: { fullcalendarWrapper },
  name: 'classtab-calendar',
  filters: {
    dateFilter
  },
  computed: {
    ...mapGetters(['events', 'currentDate', 'loading', 'viewRange', 'canSubmit', 'hadInited', 'selects', 'isSend', 'errorText', 'modifyNextWeekNumber','setSelfSchedulesEnableThisTimes']),
    calendarEvents (dialog, msg) {

      return this.events.map(e => {
        return {
          start: e.StartTime,
          end: e.EndTime,
          // 为了带进fullcalendar里  必须处理一下格式
          extendedProps: {
            ...e
          }
        }
      })

    },
    currentView: {
      get () {
        return this.$store.state[namespace].currentView
      },
      set (value) {
        this.$store.dispatch(`${namespace}/setCurrentView`, value)
      }
    },
    // weekOption1 () {
    //   return Object.assign({}, this.options, {
    //     minTime: '00:00',
    //     maxTime: '24:30',
    //     views: {
    //       timeGridSevenDays: {
    //         type: 'timeGridWeek',
    //         duration: { days: this.limitDay },
    //       }
    //     }
    //   })
    // },
    canSubmit () {
      return this.$store.state[namespace].selects.length > 0 && this.$store.state[namespace].canSubmit
    },
    isSend () {
      return this.$store.state[namespace].isSend
    },
    selfSchedulesEnable() {
      return this.$store.state.user.limitCheck && this.$store.state.user.limitCheck.SelfSchedulesEnable || false
    },
    SelfSchedulesThatDay(){
       return this.$store.state.user.limitCheck && this.$store.state.user.limitCheck.SelfSchedulesThatDay || false
    },
    setSelfSchedulesEnableThisTime() {
      return this.$store.state.user.limitCheck && this.$store.state.user.limitCheck.SelfSchedulesEnableThisTime || false
    }
  },
  watch: {
    currentView () {
      // 这个神一样的fullcalendar找不到对应的接口让它重新排列事件
      // 但是这个事件可以!
      // window.dispatchEvent(new Event('resize'))
    },
    currentDate () {
      // 日视图,切换日期的时候周日历不重复渲染事件,一次一百多个太卡了
      (this.currentDate > this.viewRange.end || this.currentDate < this.viewRange.start) && this.fullCalendarW.gotoDate(this.currentDate)
    },
   async setSelfSchedulesEnableThisTimes(value) {
      if(value && !this.selfSchedulesEnable) {
    let val= await this.$store.dispatch('getLimit')
      }
    },
    errorText (value) {
      if(value){
        this.$root.$alertTips(value, '',{ icon: { default:true } })
        this.$store.dispatch(`${namespace}/setErrorText`, '')
      }
    }
  },

  async mounted () {
    // 初始化数据 设置可放课时
    let limitCheck = await this.$store.dispatch('getLimit') // this.$store.state.user.limitCheck
    let day = limitCheck.LimitDay
    this.limitDay = day === 3 ? 3 : day === 4 ? 4 : day === 21 ? 7 : 0
    
    this.options = Object.assign({}, this.options, {
        minTime: '00:00',
        maxTime: '24:30',
        views: {
          timeGridSevenDays: {
            type: 'timeGridWeek',
            duration: { days: this.limitDay },
          }
        }
      })

    this.toolTipType = limitCheck.SelfSchedulesEnable ? 'on' : 'off'
    if (this.hadInited) {
      // 若store中已存在数据, 切换到该页面时不会触发fetchData
      // 需要手动更新一下
      this.fetchData()
    }
    await this.fullCalendarW && this.fullCalendarW.gotoDate(this.currentDate)
    
    window.onresize = () => {
      this.setSwitchDatePosition()
    };
      
    this.setSwitchDatePosition()
    this.getRestCourseCountOfNextWeek()

    this.setCurrentDate(new Date()) //初始化日期
  },
  data () {
    return {
      fullCalendarW: null,
      weekViewSpan: 0,
      options: {
        plugins: [timeGridPlugin],
        defaultView: 'timeGridSevenDays',
        columnHeader: true,
        // columnHeaderHtml: function(date) {
        //   var week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        //   let weekday = date.getDay()
        //   let dates = formatDate(date, 'MM/dd')
        //   return `<span class="calendar-title">${week[weekday]}</span> ${dates}`
        // },
        height: '500',
        contentHeight: '500',
        aspectRatio: 2.5,
        allDaySlot: false,
        header: false,
        slotLabelFormat: (e)=>{
            if(e.start.hour === 0 && e.start.minute === 0){
                return '00:00'
            }
            return `      ${(e.start.hour<10?`0${e.start.hour}`:`${e.start.hour}`)}:${(e.start.minute<10?`0${e.start.minute}`:`${e.start.minute}`)}   `
           
        },
        slotLabelInterval:'00:30:00',
        scrollTime:'09:00:00',
        views: {
          timeGridSevenDays: {
            type: 'timeGridWeek',
            // duration: { days: 7 },
          }
        },
        eventBackgroundColor: 'transparent',
        eventBorderColor: 'transparent'
      },
      weekCalendarEvent,
      num: 0,
      // 老师放课不能连续放课超过8节课（）
      // 老师放课不能放距离放课时间（提交时间）24小时之内的课时（后端验证已添加）此消息将不再提示
      // 老师不能重复设置某一天的放课时间老师在点击提交之后，当天有过课时设置的日期，该天所有时间不能再进行编辑（删除已放课时，新增课时）（后端验证已添加）此消息将不再提示
      description: [
        { color: 'yellow lighten-4', text: 'means these hours can be plotted' },
        { color: 'yellow lighten-2', text: 'means these hours have been plotted' },
        { color: 'grey lighten-2', text: 'means these hours cannot be plotted.' }
      ],
      leftBar: null,
      topBar: null,
      limitDay: 3, //限制放课天数
      toolTipType: '',
      addCount: 0,
      nextWeekNum: 0,
      modifyNextWeekNums: 0
    }
  },
  methods: {
    ...mapActions(['prev', 'next', 'today', 'setViewRange', 'fetchData', 'addSchedule', 'getLimit', 'getRestCourseCountOfNextWeek', 'setErrorText', 'setCurrentDate']),

    enSureRelease () {
      // this.$store.dispatch(`${namespace}/setIsSend`, true) 设置为发消息
      // this.$store.dispatch(`${namespace}/setIsSend`, false) 设置为不发消息
      this.$root.$confirm('Cannot be changed after submit', 'default').then((isOk) => {
        if (!isOk) return
        this.addSchedule()
      })
    },
    nextWeek () {
      this.addCount++
      this.next()
    },
    prevWeek () {
      this.addCount--
      this.prev()
    },
    setSwitchDatePosition() {
      let calendarContainer = document.getElementsByClassName("week-calendar-container")[0]

      this.$nextTick(()=>{
        document.getElementsByClassName("switch-date")[0].style.width = calendarContainer.offsetWidth + "px"
        document.getElementsByClassName("switch-date")[0].style.height = calendarContainer.offsetHeight + "px"

      })
    },
    gotoClassSetting(){
      this.$router.push({ path: '/classTab'  })
    },
    formatDate (date) {
      return formatDate(date, 'MM-dd-yyyy')
    }
  },
  destroyed() {
    window.onresize = null;
  }

}
</script>
<style scoped lang="scss">
.next-limit{
    border: 2px solid #3598dc;
    border-radius: 50%;
    min-width: 48px;
    display: inline-block;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}
.fix-height {
  height: 52px;
}
.toolbar {
  padding-top: 5px;
  padding-left: 1em;
  padding-right: 2em;
}
.calendar-container {
  margin-left: 1em;
  margin-right: 1em;
  white-space: nowrap;
}
.calendar-items {
  display: inline-block;
  width: 33%;
}
.week-calendar-container {
  white-space: nowrap;
  @include bg_color($background-color-theme);
}
.week-calendar-items {
  display: inline-block;
  width: 100%;
  @include bg_color($background-color-theme);

}
</style>
<style lang="scss">
.release-calendar .fc-time-grid-event{
  height: 42px;
}
</style>
<style lang="scss" scoped>
.calendar-card{
  box-shadow: 0px 0px 10px rgba(125, 162, 255, 0.19)!important;
  border-radius: 8px!important;
  background: #fff;
  @include font_color($font-color-theme);
}
.next-week-number{
  @include font_color($font-color-theme);
  font-weight: bold;
  span{
    color: $pink-btn-background;
  }
}
</style>
